import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";

const StyledInputWrapper = styled(Row)`
  margin-bottom: 0rem;
`;

const InputWrapper = ({ children, ...props }) => {
  return (
    <StyledInputWrapper {...props}>
      <Col xs={12}>{children}</Col>
    </StyledInputWrapper>
  );
};

export default InputWrapper;
